// extracted by mini-css-extract-plugin
export var buttonContent = "_38-0";
export var centered = "_38-1";
export var centeredFlex = "_38-2";
export var errorText = "_38-3";
export var icon = "_38-4";
export var iconButtonContent = "_38-5";
export var monospace = "_38-6";
export var padded = "_38-7";